











































import { defineComponent, toRefs, reactive } from '@vue/composition-api'
import TemplateTable from '@/components/template-table/index.vue'
import $http from '@/api'
import useTable from './composables/useTable'
import { omit } from 'lodash'
import { MessageBox, Message } from 'element-ui'
const pageDefaultNum = 1
const pageDefaultSize = 10

export default defineComponent({
  name: 'ApiAuth',
  components: {
    TemplateTable
  },
  setup(props, { root: { $router, $route } }) {
    const { id } = $route.params
    const state: any = reactive({
      formInfo: {
        apiName: ''
      },
      pageInfo: {
        page: pageDefaultNum,
        count: pageDefaultSize,
        total: 0
      },
      multipleSelection: [],
      list: []
    })
    const { columns, operations } = useTable()
    const getList = async () => {
      const params = {
        appId: id,
        ...state.formInfo,
        ...omit(state.pageInfo, 'total'),
        status: '2'
      }
      const { data = {} } = await $http.getCanApplyApiList(params)
      const { list = [], total = 0 } = data
      state.list = list
      state.pageInfo.total = total
      // 用于处理最后一页最后一条删除
      if (params.page > Math.ceil(total / params.count) && params.page > 1) {
        state.pageInfo.page--
        getList()
      }
    }
    const currentChange = (page: number) => {
      state.pageInfo.page = page
      getList()
    }
    const sizeChange = (size: number) => {
      state.pageInfo.page = pageDefaultNum
      state.pageInfo.count = size
      getList()
    }
    const search = () => {
      state.pageInfo.page = pageDefaultNum
      getList()
    }
    const operationEvent = (row: any, role: string) => {
      if (role === 'open') {
        AuthFun([row])
      }
    }
    getList()
    const submit = () => {
      if (!state.multipleSelection?.length) {
        Message.warning('请勾选API')
        return
      }
      AuthFun(state.multipleSelection)
    }
    const AuthFun = async (list: Array<any>) => {
      MessageBox.prompt('', '申请理由', {
        inputType: 'textarea',
        inputPlaceholder: '请输入申请理由',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnPressEscape: false,
        closeOnClickModal: false,
        showClose: true,
        inputValidator: (val) => {
          if (!val?.trim()) {
            return '请输入申请理由'
          } else if (val.length > 200) {
            return '申请理由不超过200字符'
          } else {
            return true
          }
        }
      })
        .then(async ({ value }: any) => {
          const params = {
            apiIdList: list.map((item) => item.apiId),
            appId: id,
            applyInfo: value.trim()
          }
          const { errNo } = await $http.commitApply(params)
          if (errNo === 0) {
            Message.success('提交成功')
            getList()
          }
        })
        .catch(() => {})
    }
    const backFun = () => {
      $router.back()
    }
    return {
      ...toRefs(state),
      getList,
      currentChange,
      sizeChange,
      search,
      columns,
      operations,
      operationEvent,
      submit,
      backFun
    }
  }
})
